module.exports = __webpack_public_path__ + "static/media/nedel.c739aea9.jpg";